// Numeric values mirror RAK.Shared.WebBanners (the API serialises enums as numbers).

export const PAGE = { LANDING: 1, STORE: 2, CATALOG: 3, PRODUCT: 4, CART: 5, CHECKOUT: 6 };
export const SLOT = { TOP: 1, AFTER_SECTION: 2, BOTTOM: 3 };
export const TYPE = { INLINE: 0, POPUP: 1 };
export const ACTION = { NONE: 0, URL: 1, SECTION: 2, PRODUCT: 3, BRAND: 4 };

export const PAGES = [
  { value: PAGE.LANDING, en: 'Entry page (/)', ar: 'الصفحة الأولى (/)', sections: true },
  { value: PAGE.STORE, en: 'Store home (/store)', ar: 'الصفحة الرئيسية للمتجر (/store)', sections: true },
  { value: PAGE.CATALOG, en: 'Products page', ar: 'صفحة المنتجات', sections: false },
  { value: PAGE.PRODUCT, en: 'Product details page', ar: 'صفحة تفاصيل المنتج', sections: false },
  { value: PAGE.CART, en: 'Cart page', ar: 'صفحة السلة', sections: false },
  { value: PAGE.CHECKOUT, en: 'Checkout page', ar: 'صفحة إتمام الطلب', sections: false },
];

export const pageMeta = (v) => PAGES.find((p) => p.value === v) || PAGES[1];

export const SLOTS = [
  { value: SLOT.TOP, en: 'Top of the page', ar: 'أعلى الصفحة' },
  { value: SLOT.AFTER_SECTION, en: 'Under a section', ar: 'تحت قسم محدد' },
  { value: SLOT.BOTTOM, en: 'Bottom of the page', ar: 'أسفل الصفحة' },
];

export const FREQUENCIES = [
  { value: 0, en: 'Every time the page opens', ar: 'في كل مرة تُفتح الصفحة' },
  { value: 1, en: 'Once per visit (session)', ar: 'مرة واحدة في كل زيارة' },
  { value: 2, en: 'Once per day', ar: 'مرة واحدة في اليوم' },
  { value: 3, en: 'Once per device (until edited)', ar: 'مرة واحدة لكل جهاز (حتى يُعدَّل الإعلان)' },
];

export const ACTIONS = [
  { value: ACTION.NONE, en: 'Nothing (not clickable)', ar: 'لا شيء (غير قابل للنقر)' },
  { value: ACTION.URL, en: 'Open a link', ar: 'فتح رابط' },
  { value: ACTION.SECTION, en: 'Open a content section', ar: 'فتح قسم محتوى' },
  { value: ACTION.PRODUCT, en: 'Open a product', ar: 'فتح منتج' },
  { value: ACTION.BRAND, en: 'Open a brand', ar: 'فتح ماركة' },
];

export const STATUSES = [
  { value: 'live', en: 'Live', ar: 'ظاهر', badge: 'badge-success' },
  { value: 'scheduled', en: 'Scheduled', ar: 'مجدول', badge: 'badge-info' },
  { value: 'expired', en: 'Expired', ar: 'منتهي', badge: 'badge-warning' },
  { value: 'inactive', en: 'Inactive', ar: 'معطّل', badge: 'badge-neutral' },
];

export const statusMeta = (v) => STATUSES.find((s) => s.value === v) || STATUSES[3];

/** Where a banner sits, as one readable line. */
export const placementLabel = (b, isRtl) => {
  if (b.displayType === TYPE.POPUP) {
    const f = FREQUENCIES.find((x) => x.value === b.popupFrequency);
    return `${isRtl ? 'منبثق' : 'Popup'} · ${b.popupDelaySeconds}${isRtl ? ' ث' : 's'} · ${f ? (isRtl ? f.ar : f.en) : ''}`;
  }
  if (b.slot === SLOT.AFTER_SECTION) return `${isRtl ? 'تحت' : 'Under'}: ${b.anchorSectionTitle || '—'}`;
  return isRtl ? SLOTS.find((s) => s.value === b.slot).ar : SLOTS.find((s) => s.value === b.slot).en;
};

export { toLocalInput, toUtcIso, extractErrors } from '../ContentSections/constants';
